<template>
  <div class="wrapper">
    <FORM ref="childForm" @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable" :pageData="pageData"></table-page>
  </div>
</template>

<script>
import tablePage from '@/components/page/table.vue'
import FORM from '@/components/page/form.vue'
import DateUtil from '@/utils/IM/tradeDataUtil.js'
import Qs from 'qs'
import Url from '@/views/crs/util/url'
import download from '@/utils/download'

export default {
  name: 'list',
  components: {
    tablePage,
    FORM
  },
  methods: {

    /*查询表单按钮点击事件*/
    formclick(clickName, data) {
      if (window.$t('common.search') == clickName || '查询' == clickName) {
        this.queryData = data
        this.$refs.childTable.defaultGetData(data)
      }else if (window.$t('common.export') == clickName || '导出' == clickName) {
        this.queryData = data
        download.exportExcel(Url.quantityTask.balanceExport, data, '積分餘額列表')
      }
    }
  },
  data() {
    return {
      queryData: {},
      /*from查询表单*/
      formData: {
        hasLable: true,
        cols: [
          {
            title: 'businessTypeAlias',
            field: 'businessTypeAlias',
            data: DateUtil.getParamKey(this.$route.params),
            hidden: true
          },
          { title: window.$t('crs.quantityTask.customerNumber'), field: 'customerNumber', isNumber: true },
          { click: window.$t('common.search') },
          { click: window.$t('common.export'), auth: 'crs:balance:export' }
        ]
      },
      /*table生成*/
      pageData: {
        isShow: false,
        queryUrl: Url.quantityTask.balanceQuery,
        selection: false,
        sequence: false,
        method: 'get',
        cols: [
          { title: window.$t('crs.quantityTask.customerNumber'), field: 'customerNumber' },
          {
            title: window.$t('crs.quantityTask.activeTime'), field: 'activeTime', render: (data, full) => {
              if (data > 0) {
                return DateUtil.formatDate(data, 'yyyy-MM-dd hh:mm:ss')
              }
              return null
            }
          },
          { title: window.$t('crs.quantityTask.userName'), field: 'userName' },
          { title: window.$t('crs.quantityTask.phone'), field: 'phone' },
          { title: window.$t('crs.quantityTask.quantity'), field: 'quantity' }
        ]
      }
    }
  }
}
</script>
